import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunks for async actions
export const fetchWishlist = createAsyncThunk(
  "wishlist/fetchWishlist",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/api/wishlist");
      console.log("response", response.data.data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch wishlist"
      );
    }
  }
);

export const addToWishlistAsync = createAsyncThunk(
  "wishlist/addToWishlist",
  async ({ productId, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/api/wishlist", {
        product_id: productId,
        user_id: userId, // Include userId in the request
      });
      console.log("Response from adding to wishlist:", response);
      return response.data.data; // Adjust according to your API response structure
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add item to wishlist"
      );
    }
  }
);


export const removeFromWishlistAsync = createAsyncThunk(
  "wishlist/removeFromWishlist",
  async (wishlistItemId, { rejectWithValue }) => {
    try {
      await axios.delete(`/api/api/wishlist/${wishlistItemId}`);
      return wishlistItemId;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to remove item from wishlist"
      );
    }
  }
);

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState: {
    wishlist: [],
    loading: false,
    error: null,
  },
  reducers: {
    removeFromWishlist(state, action) {
      state.wishlist = state.wishlist.filter(
        (item) => item._id !== action.payload
      );
    },
    addToWishlist(state, action) {
      state.wishlist.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Wishlist
      .addCase(fetchWishlist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWishlist.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = action.payload;
      })
      .addCase(fetchWishlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Add to Wishlist
      .addCase(addToWishlistAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToWishlistAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist.push(action.payload);
      })
      .addCase(addToWishlistAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Remove from Wishlist
      .addCase(removeFromWishlistAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeFromWishlistAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = state.wishlist.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(removeFromWishlistAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { removeFromWishlist, addToWishlist } = wishlistSlice.actions;

export default wishlistSlice.reducer;
